/**
 * Shop by Need — category filtering, carousel, hover video
 */
(function () {
  'use strict';

  function ShopByNeed(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.selectedCategory = root.dataset.defaultCategory || 'all';
    this.hoverTransition = parseInt(root.dataset.hoverMs, 10) || 350;

    this.tabs = root.querySelectorAll('[data-category-tab]');
    this.featured = root.querySelector('[data-featured-card]');
    this.track = root.querySelector('[data-carousel-track]');
    this.cards = root.querySelectorAll('[data-product-card]');
    this.prevBtn = root.querySelector('[data-carousel-prev]');
    this.nextBtn = root.querySelector('[data-carousel-next]');
    this.carouselWrap = root.querySelector('.shop-by-need__carousel-wrap');
    this._fadeOutTimer = null;
    this._fadeInTimer = null;
    this._onFadeOutEnd = null;
    this._fadeOutHandled = false;

    this.dedupeProductCards();
    this.bind();
    this.setCategory(this.selectedCategory, { instant: true });
    this.updateArrows();
  }

  ShopByNeed.prototype.dedupeProductCards = function () {
    var map = {};
    var cards = Array.prototype.slice.call(this.cards);

    cards.forEach(function (card) {
      var id = card.dataset.productId;
      if (!id) return;

      if (map[id]) {
        var existing = map[id];
        var merged = (existing.dataset.categories + ',' + card.dataset.categories)
          .split(',')
          .filter(function (v, i, a) {
            return v && a.indexOf(v) === i;
          })
          .join(',');
        existing.dataset.categories = merged;
        card.parentNode.removeChild(card);
      } else {
        map[id] = card;
      }
    });

    this.cards = this.root.querySelectorAll('[data-product-card]');
  };

  ShopByNeed.prototype.bind = function () {
    var self = this;

    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var handle = tab.dataset.categoryHandle;
        if (handle === self.selectedCategory) return;
        self.selectedCategory = handle;
        self.setCategory(handle);
      });
    });

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.scrollCarousel(-1);
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.scrollCarousel(1);
      });
    }

    if (this.track) {
      this.track.addEventListener('scroll', function () {
        self.updateArrows();
      });
    }

    this.cards.forEach(function (card) {
      if (!card.classList.contains('shop-by-need__card--has-hover')) {
        return;
      }

      var link = card.querySelector('.shop-by-need__card-link');
      var video = card.querySelector('.shop-by-need__card-video');

      if (!link) return;

      var playVideo = function () {
        if (video && typeof video.play === 'function') {
          var playPromise = video.play();
          if (playPromise && playPromise.catch) {
            playPromise.catch(function () {});
          }
        }
      };

      var pauseVideo = function () {
        if (video && typeof video.pause === 'function') {
          video.pause();
          try {
            video.currentTime = 0;
          } catch (e) {}
        }
      };

      link.addEventListener('mouseenter', function () {
        card.classList.add('is-hover');
        playVideo();
      });

      link.addEventListener('mouseleave', function () {
        card.classList.remove('is-hover');
        pauseVideo();
      });

      link.addEventListener('focusin', function () {
        card.classList.add('is-hover');
        playVideo();
      });

      link.addEventListener('focusout', function () {
        card.classList.remove('is-hover');
        pauseVideo();
      });
    });
  };

  ShopByNeed.prototype.applyCategoryFilter = function (active) {
    this.cards.forEach(function (card) {
      var categories = (card.dataset.categories || '').split(',');
      var visible = categories.indexOf(active) !== -1 || active === 'all';
      card.classList.toggle('is-filtered-out', !visible);
    });
  };

  ShopByNeed.prototype.cancelCategoryTransition = function (keepSwitchingState) {
    if (this._fadeOutTimer) {
      window.clearTimeout(this._fadeOutTimer);
      this._fadeOutTimer = null;
    }

    if (this._fadeInTimer) {
      window.clearTimeout(this._fadeInTimer);
      this._fadeInTimer = null;
    }

    if (this._onFadeOutEnd && this.track) {
      this.track.removeEventListener('transitionend', this._onFadeOutEnd);
      this._onFadeOutEnd = null;
    }

    if (!keepSwitchingState) {
      this._fadeOutHandled = false;

      if (this.track) {
        this.track.classList.remove('is-switching');
        this.track.style.removeProperty('--sbn-fade-ms');
      }

      if (this.carouselWrap) {
        this.carouselWrap.classList.remove('is-switching');
      }

      if (this.featured) {
        this.featured.classList.remove('is-no-transition');
      }
    }
  };

  ShopByNeed.prototype.completeCategorySwap = function (active) {
    var self = this;

    if (this._fadeOutHandled) return;
    this._fadeOutHandled = true;

    if (this._fadeOutTimer) {
      window.clearTimeout(this._fadeOutTimer);
      this._fadeOutTimer = null;
    }

    if (this._onFadeOutEnd && this.track) {
      this.track.removeEventListener('transitionend', this._onFadeOutEnd);
      this._onFadeOutEnd = null;
    }

    if (this.featured) {
      this.featured.classList.add('is-no-transition');
    }

    this.updateFeatured(active);
    this.applyCategoryFilter(active);

    if (this.track) {
      this.track.scrollLeft = 0;
      void this.track.offsetHeight;
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (self.featured) {
          self.featured.classList.remove('is-no-transition');
        }

        if (self.track) {
          self.track.classList.remove('is-switching');
        }

        if (self.carouselWrap) {
          self.carouselWrap.classList.remove('is-switching');
        }

        var fadeMs = Math.max(300, Math.round(self.hoverTransition * 0.55));
        self._fadeInTimer = window.setTimeout(function () {
          self._fadeInTimer = null;
          self.updateArrows();
        }, fadeMs);
      });
    });
  };

  ShopByNeed.prototype.setCategory = function (handle, options) {
    options = options || {};
    var self = this;
    var active = handle || 'all';
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.tabs.forEach(function (tab) {
      var isSelected = tab.dataset.categoryHandle === self.selectedCategory;
      tab.classList.toggle('is-active', isSelected);
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    if (!this.track || options.instant || prefersReducedMotion) {
      this.cancelCategoryTransition(false);
      this.updateFeatured(active);
      this.applyCategoryFilter(active);
      if (this.track) {
        this.track.scrollLeft = 0;
        this.updateArrows();
      }
      return;
    }

    var isMidFade = this.track.classList.contains('is-switching');
    this.cancelCategoryTransition(isMidFade);

    if (isMidFade) {
      this._fadeOutHandled = false;
      this.completeCategorySwap(active);
      return;
    }

    var fadeMs = Math.max(300, Math.round(this.hoverTransition * 0.55));
    this.track.style.setProperty('--sbn-fade-ms', fadeMs + 'ms');
    this._fadeOutHandled = false;

    this._onFadeOutEnd = function (event) {
      if (event.target !== self.track || event.propertyName !== 'opacity') return;
      self.completeCategorySwap(active);
    };

    this.track.addEventListener('transitionend', this._onFadeOutEnd);
    this._fadeOutTimer = window.setTimeout(function () {
      self.completeCategorySwap(active);
    }, fadeMs + 80);

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (self.carouselWrap) {
          self.carouselWrap.classList.add('is-switching');
        }
        self.track.classList.add('is-switching');
      });
    });
  };

  ShopByNeed.prototype.updateFeatured = function (handle) {
    if (!this.featured) return;

    var panels = this.featured.querySelectorAll('[data-featured-panel]');
    panels.forEach(function (panel) {
      var isActive = panel.dataset.featuredPanel === handle;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
        var video = panel.querySelector('video');
        if (video && typeof video.play === 'function') {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
      } else {
        panel.setAttribute('hidden', '');
        var inactiveVideo = panel.querySelector('video');
        if (inactiveVideo && typeof inactiveVideo.pause === 'function') {
          inactiveVideo.pause();
        }
      }
    });
  };

  ShopByNeed.prototype.scrollCarousel = function (direction) {
    if (!this.track) return;
    var card = this.track.querySelector('[data-product-card]:not(.is-filtered-out), .shop-by-need__featured');
    var amount = card ? card.offsetWidth + parseInt(getComputedStyle(this.track).gap, 10) || 16 : 300;
    this.track.scrollBy({ left: direction * amount, behavior: 'smooth' });
  };

  ShopByNeed.prototype.updateArrows = function () {
    if (!this.track) return;
    var maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
    if (this.prevBtn) {
      this.prevBtn.disabled = this.track.scrollLeft <= 2;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = this.track.scrollLeft >= maxScroll;
    }
  };

  function init(root) {
    if (!root || root.dataset.shopByNeedInit === 'true') return;
    root.dataset.shopByNeedInit = 'true';
    new ShopByNeed(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-shop-by-need]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-shop-by-need]');
    if (root) {
      delete root.dataset.shopByNeedInit;
    }
  });
})();
